module.exports = __webpack_public_path__ + "img/boite2.17240729.png";